import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Contact, ContactQuery} from '@services/resource/contact-query';
import {ConfigService} from '@services/infra/config.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {JobInfo} from '@services/resource/job-info';
import {notFoundAsNull} from '@util/http';

@Injectable({
  providedIn: 'root',
})
export class MailjetExportService {
  constructor(
    private readonly conf: ConfigService,
    private readonly http: HttpClient,
  ) {}

  exportList(name: string, query: ContactQuery): Observable<ExportJobDTO> {
    const url = `${this.conf.backendUrl}/v1/mailjet-export/job`;
    const params = new HttpParams().set('name', name);
    return this.http.post<ExportJobDTO>(url, query, {params});
  }

  previewQuery(query: ContactQuery): Observable<Contact[]> {
    const url = `${this.conf.backendUrl}/v1/mailjet-export/preview`;
    return this.http.post<object>(url, query).pipe(map((x) => (x as any).contacts));
  }

  getStatus(jobId: number): Observable<JobInfo | null> {
    const url = `${this.conf.backendUrl}/v1/mailjet-export/job/${jobId}`;
    return this.http.get<JobInfo>(url).pipe(notFoundAsNull());
  }
}

export class ExportJobDTO {
  constructor(
    public readonly listId: number,
    public readonly jobId: number,
  ) {}
}
